/* @flow */

export default {
  root: {
    width: 44,
    height: 60,
  },
};
